import { render, staticRenderFns } from "./cashierInfo.vue?vue&type=template&id=5e893fcc&scoped=true&"
import script from "./cashierInfo.vue?vue&type=script&lang=js&"
export * from "./cashierInfo.vue?vue&type=script&lang=js&"
import style0 from "./cashierInfo.vue?vue&type=style&index=0&id=5e893fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e893fcc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e893fcc')) {
      api.createRecord('5e893fcc', component.options)
    } else {
      api.reload('5e893fcc', component.options)
    }
    module.hot.accept("./cashierInfo.vue?vue&type=template&id=5e893fcc&scoped=true&", function () {
      api.rerender('5e893fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale/detail/components/cashierInfo.vue"
export default component.exports